import baseApi from "../baseApi"

const buildUrl = (endpoint) =>
  `/book/ai_chat_bot${endpoint && endpoint.toString().length > 0 ? `/${endpoint}` : ""}`

export const aiChatBotService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAiChatBotHistory: builder.query({
      query: () => ({
        url: buildUrl("history"),
        method: "GET",
      }),
    }),

    sendAiChatBotMessage: builder.mutation({
      query: (arg) => {
        const { text, conversation_id } = typeof arg === "string" ? { text: arg } : arg
        return {
          url: buildUrl("message"),
          method: "POST",
          body: conversation_id ? { text, conversation_id } : { text },
        }
      },
    }),

    getPublicAiHistory: builder.query({
      query: ({ key, token }) => ({
        url: `/book/public_ai/${key}/history`,
        method: "GET",
        params: { token },
      }),
    }),

    sendPublicAiMessage: builder.mutation({
      query: ({ key, text, token }) => ({
        url: `/book/public_ai/${key}/message`,
        method: "POST",
        body: { text, token },
      }),
    }),

    flagAiChatBotMessage: builder.mutation({
      query: ({ id, comment }) => ({
        url: buildUrl(`messages/${id}/flag`),
        method: "POST",
        body: { comment },
      }),
    }),

    startNewAiChatBotConversation: builder.mutation({
      query: () => ({
        url: buildUrl("new_conversation"),
        method: "POST",
      }),
    }),

    getMyAiChatBotConversations: builder.query({
      query: (params) => ({
        url: buildUrl("my_conversations"),
        method: "GET",
        params,
      }),
    }),

    restoreAiChatBotConversation: builder.mutation({
      query: (id) => ({
        url: buildUrl(`my_conversations/${id}/restore`),
        method: "POST",
      }),
    }),

    getAiChatBotConversations: builder.query({
      query: (params) => {
        const cleaned = Object.fromEntries(
          Object.entries(params || {}).filter(
            ([_, v]) => v !== null && v !== 0 && !(Array.isArray(v) && v.length === 0)
          )
        )
        return {
          url: buildUrl("conversations"),
          method: "GET",
          params: cleaned,
        }
      },
    }),

    deleteAiChatBotConversation: builder.mutation({
      query: (id) => ({
        url: buildUrl(`my_conversations/${id}`),
        method: "DELETE",
      }),
    }),

    getAiChatBotConversationDetail: builder.query({
      query: (params) => ({
        url: buildUrl(`conversations/${params.bundle_id}`),
        method: "GET",
      }),
    }),
  }),
})

export const {
  useGetAiChatBotHistoryQuery,
  useGetPublicAiHistoryQuery,
  useSendPublicAiMessageMutation,
  useSendAiChatBotMessageMutation,
  useFlagAiChatBotMessageMutation,
  useStartNewAiChatBotConversationMutation,
  useGetMyAiChatBotConversationsQuery,
  useDeleteAiChatBotConversationMutation,
  useRestoreAiChatBotConversationMutation,
  useGetAiChatBotConversationsQuery,
  useGetAiChatBotConversationDetailQuery,
  useLazyGetAiChatBotConversationsQuery,
  useLazyGetAiChatBotConversationDetailQuery,
} = aiChatBotService
